module.exports = __webpack_public_path__ + "static/assets/5f590c5fe96bfb29cea74eebed1aee40.svg";